import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { useMutation } from "@apollo/client";
import { ADD_USER } from "../utils/mutations";
import Auth from "../utils/auth";



const Section = styled.div`
  width: 60%;
  height: auto;
  margin: 15vh auto 4vh auto;
  border: 4px solid burlywood;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  height: auto;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const Details = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 1.5rem;
  /* border: 1px solid red; */

  input {
    display: block;
    margin: 0.5rem 0;
    margin-bottom: 0.8rem;
    font-size: 1rem;
    padding: 0.2rem 0.6rem;
    border: 2px solid purple;
    border-radius: 4px;
  }

  .submit{
    padding: 0.2rem 0.4rem;
    border: 2px solid black;
    border-radius: 4px;
    font-size: 1.2rem;
    margin: 1rem 0;
    cursor: pointer;
  }
`;

const SignUp = () => {
    const [userFormData, setUserFormData] = useState({
      name: "",
      email: "",
      password: "",
    });

    const [addUser, { error }] = useMutation(ADD_USER);

    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setUserFormData({ ...userFormData, [name]: value });
    };

    const handleFormSubmit = async (event) => {
      event.preventDefault();
  
      // check if form has everything (as per react-bootstrap docs)
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      try {
        const { data } = await addUser({
          variables: { ...userFormData },
        });
        Auth.login(data.addUser.token);
      } catch (e) {
        console.error(e);
      }
  
      setUserFormData({
        username: "",
        email: "",
        password: "",
      });
    };
    
  return (
    <Section>
    <Header>SignUp</Header>
      <Details>
        <form onSubmit={handleFormSubmit}>
        <label>
        Name
        <input type="text" placeholder='Name' name="name" onChange={handleInputChange}/>
        </label>
          <label>
            E-mail
            <input
              type="email" 
              name="email"
              placeholder="e-mail"
              onChange={handleInputChange}
            />
          </label>
          <label>
            Password
            <input 
             type="password"
             name="password"
             placeholder="password" 
             onChange = {handleInputChange} />
          </label>
          <Link to="/">
          <input type="submit" value="Submit" className="submit"/>
          </Link>
        </form>
      </Details>
      </Section>
  )
}

export default SignUp